export const SET_SELECTED_SESSION_COLLECTION = 'SET_SELECTED_SESSION_COLLECTION'
